<template>
  <div style="font-size: 0.9rem;margin-left: 20px;margin-right: 30px;">
    <el-row style="border-bottom: 1px solid rgba(41, 155, 255, .2);padding: 30px 0 0 0;">
      <el-button size="mini" class="button" style="margin-bottom: 5px" @touchstart="createAlterNate" @click="createAlterNate">
        新增
      </el-button>
      <el-collapse>
      </el-collapse>
    </el-row>
    <el-row class="device overflow" style="overflow: auto;height: calc(100vh - 150px)">
      <ul style="padding: 0">
        <li :key="item.id" v-for="item in deviceList">
          <alternate-device-detail :data="item" @edit="createAlterNate" @deleteById="deleteById"></alternate-device-detail>
        </li>
      </ul>
    </el-row>
    <function-dialog-component
      :closeClick="false"
      :dialog-title="title"
      :dialogVisible.sync="deviceDialogVisible"
      @dialogClose="() => {this.deviceDialogVisible = false;this.form={};}"
      center
      width="40vw">
      <div slot="content" style="padding: 10px 30px 20px 30px;">
        <alternate-device-modify :form="form" :spaceTree="spaceTree" ref="alternateModify">
        </alternate-device-modify>
      </div>
      <div class="dialog-footer" slot="footer" style="text-align: center;margin-bottom: 15px;">
        <el-button @touchstart="() => {this.deviceDialogVisible = false;this.form={};}" @click="() => {this.deviceDialogVisible = false;this.form={};}" size="mini">关 闭</el-button>
        <el-button @touchstart="preservation" @click="preservation" size="mini" type="primary">保 存</el-button>
      </div>
    </function-dialog-component>
  </div>
</template>

<script>
import FunctionDialogComponent from "@/components/FunctionDialogComponent";
import AlternateDeviceModify
  from "@/views/basic_operations/device_management/alternate_device/comp/alternate_device_modify"
import AlternateDeviceDetail
  from "@/views/basic_operations/device_management/alternate_device/comp/alternate_device_detail"
import {getSpaceTreeData, getTreeHaveDisabled} from "@/network/space-info";
import {save, getList,update, deleteById} from "@/network/alternate_device"

export default {
  name: "alternate_device",
  components: {FunctionDialogComponent, AlternateDeviceModify, AlternateDeviceDetail},
  data() {
    return {
      // 空间树
      spaceTree: [{
        value: '',
        label: ''
      }],
      deviceList: [],
      form: {},
      title: '新增告警屏蔽策略',
      // 当前空间id
      spaceInfoId: '',
      deviceDialogVisible: false,
    }
  },
  created() {
    this.getDateInfo();
    this.getSpaceTreeData();
  },
  methods: {
    getDateInfo() {
      getList(true).then(res => {
        this.deviceList = res.data;
      });
    },
    getSpaceTreeData() {
      getSpaceTreeData().then(res => {
        if (res.code === 0) {
          // 将树转换成需要的格式
          this.spaceTree = getTreeHaveDisabled(res.data);
        }
      });
    },
    // 保存
    preservation() {
      let form = this.$refs.alternateModify.getForm();
      console.log(form, '----')
      if(form.ordinal===''){
        this.$message.warning("请填写排序！！")
        return
      }
      if(form.id){
        update(form).then(res => {
          if (res.code == 0) {
            this.$message.success("编辑成功!")
            this.form = {}
            this.deviceDialogVisible = false;
            this.getDateInfo()
          }
        });
      }else{
        save(form).then(res => {
          if (res.code == 0) {
            this.$message.success("保存成功!")
            this.form = {}
            this.deviceDialogVisible = false;
            this.getDateInfo()
          }
        });
      }
    },
    createAlterNate(data) {
      if(data){
        this.title = '编辑暖通设备';
        this.selectId = 0;
        this.form = data;
        this.deviceDialogVisible = true;
      }else{
        this.title = '新增暖通设备';
        this.selectId = 0;
        this.form = {};
        this.deviceDialogVisible = true;
      }
    },
    deleteById(id){
      deleteById(id).then(res => {
        if (res.code === 0) {
          this.$message.success("删除成功!")
          this.getDateInfo()
        }
      });
    }
  }
}
</script>

<style scoped>
.main {
  padding: 10px 10px 0;
  height: calc(100vh - 90px);
}

ul li {
  list-style: none;
  float: left;
}
/*设备列表*/
.device-list {
  margin-left: 250px;
  width: calc(100vw - 485px);
}


.device-list .device {
  overflow: auto;
  height: calc(100vh - 140px);
}
.nav-bar-div {
  width: 100%;
  overflow: auto;
}

@media (max-width: 1245px) {
  .device-list .device {
    overflow: auto;
    height: calc(100vh - 240px);
  }
}
@media (max-width: 800px) {
  .device-list {
    margin-left: 0;
    width: auto;
  }
}
</style>
